import initModals from './components/modal';
import initAppearAnim from "./utils/appear-anim";
import initDropdown from "./utils/dropdown";
import initTabs from './utils/tabs';
import initSimpleSwiper from './utils/simple-swiper';
import initReadMore from './utils/read-more';
import initFormFilters from "./components/form-filters";
import initAsideFilters from './components/aside-filters';
import initHeaderNavigation from './template-parts/header-navigation';
import initCarouselPosts from "./blocks/carousel-posts";
import initCarouselTextImageVideo from "./blocks/text-image-video-carousel";
import initCustomNav from "./components/nav-custom";
import initSingleContentSlider from "./template-parts/single-content-slider";
import { initYoutubeIframe } from './components/youtube-iframe';
import initPasswordToggler from './components/password-toggler';
import initListeLogos from './blocks/liste-logos';
import initTeam from './blocks/team';
import initListeEtablissements from './blocks/liste-etablissements';
import initAlert from './components/alert';
import initUploadForm from './components/input-file';
import initDashboardToggleContent from './components/dashboard-toggle-content';
import initNotificationsDashboard from './template-parts/notifications';
import initNotificationsPreferences from './components/notifications-preferences';
import initLikes from './components/likes';
import initFormWithCart from './components/form-with-cart';
import initRetrievePassword from './template-parts/profile-password';
import initDownloadBlob from './components/download-blob';
import initbaseDocumentaireScroll from './template-parts/base-documentaire-scroll';
import { initAnnuaireSearchAutocomplete } from './template-parts/annuaire-search';
import { initBaseDocumentaireSearchAutocomplete } from './template-parts/base-documentaire-search';
import initFormRepeater from './template-parts/form-repeater';
import initForumReplyForm from './template-parts/forum-reply-form';
import initForumPublishForm from './template-parts/forum-publish-form';

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

// Utils
initAppearAnim();
initDropdown();
initTabs();
initSimpleSwiper();
initReadMore();
initUploadForm();
initDashboardToggleContent();

// Template parts
initHeaderNavigation();
initSingleContentSlider();
initNotificationsDashboard();
initDownloadBlob();
initbaseDocumentaireScroll();
initAnnuaireSearchAutocomplete();
initBaseDocumentaireSearchAutocomplete();
// Blocks
initCarouselPosts();
initListeLogos();
initTeam();
initListeEtablissements();
initCarouselTextImageVideo();

// Components
initFormFilters();
initAsideFilters();
initModals();
initYoutubeIframe();
initPasswordToggler();
initCustomNav();
initAlert();
initNotificationsPreferences();
initLikes();
initFormWithCart();
initRetrievePassword();
initFormRepeater();

initForumReplyForm();
initForumPublishForm();
